import React, { Component } from 'react';
import { Popconfirm, Icon, Row } from 'antd';
import Table from '../../components/generic/table/Table';
import {
  PageContainer,
  PageTitle,
  HeaderContainer,
  HeaderTitle,
  HeaderButtonsContainer,
  TableButton
} from '../../styles/BasicStyles';
import {
  GetTeams,
  DeleteTeam,
  GetTeamsPDF
} from '../../infra/requests/TeamsRequests';
import BaseButton from '../../components/generic/buttons/BaseButton';
import TeamsFilters from './TeamsFilters';
import { getQuerySortName } from '../../infra/services/utils/QuerySortTypes';
import MultiOptionButton from '../../components/base/MultiOptionButton';
import moment from 'moment';

class TeamsPage extends Component {
  state = {
    pageSize: 30,
    currentPage: 1,
    filters: '',
    sorter: '',
    loading: false,
    columns: [
      {
        title: 'Nome',
        sorter: true,
        dataIndex: 'name'
      },
      {
        title: 'Elementos',
        dataIndex: 'contributors',
        render: (contributors) => contributors.length
      },
      {
        title: '',
        render: (data) => (
          <React.Fragment>
            <TableButton error onClick={(e) => e.stopPropagation()}>
              <Popconfirm
                placement="topRight"
                title="Tem a certeza que quer remover a equipa?"
                onConfirm={() => this.removeTeam(data)}
              >
                <Icon style={{ marginRight: 10 }} type="delete" />
                {'Remover'}
              </Popconfirm>
            </TableButton>
          </React.Fragment>
        )
      }
    ],
    rows: [],
    total: 0
  };

  componentDidMount = async () => {
    await this.updateDataTable();
  };

  handleOnPressRow = (record) => {
    const { history } = this.props;
    history.push(`/teams/${record._id}`);
  };

  handleChangePage = (currentPage) => {
    this.setState({ currentPage }, this.updateDataTable);
  };

  handleChangeRowsPerPage = (currentSize, pageSize) => {
    this.setState({ pageSize, currentPage: 1 }, this.updateDataTable);
  };

  removeTeam = async (data) => {
    try {
      await DeleteTeam(data._id);
      await this.updateDataTable();
    } catch (e) {
      console.error(e);
    }
  };

  updateDataTable = async () => {
    this.setState({ loading: true });
    try {
      const { currentPage, pageSize, filters, sorter } = this.state;
      const result = await GetTeams(currentPage, pageSize, filters, sorter);
      this.setState({
        rows: result.data.items,
        total: result.data.total,
        loading: false
      });
    } catch (e) {
      this.setState({ loading: false });
      console.error(e);
    }
  };

  handleTableChange = (pagination, filters, sorter) => {
    const sortObject = JSON.stringify({
      [sorter.field]: getQuerySortName(sorter.order)
    });
    this.setState({ sorter: sortObject }, this.updateDataTable);
  };

  handleFilterChange = (filters) => {
    this.setState({ filters }, this.updateDataTable);
  };

  onPressChoice = async (event) => {
    const today = moment().format('DD_MM_YYYY');
    const filename = 'Lista_Equipas';

    if (event.key === 'Mapa de equipa') {
      const requestBlob = await GetTeamsPDF();
      const url = URL.createObjectURL(requestBlob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${filename}_${today}.pdf`;
      return a.click();
    }
  };

  render() {
    const { columns, rows, total, loading, currentPage, pageSize } = this.state;
    const { history } = this.props;
    return (
      <React.Fragment>
        <HeaderContainer>
          <HeaderTitle buttons={2}>
            <PageTitle>Lista de Equipas</PageTitle>
            {'Equipas'}
          </HeaderTitle>
          <HeaderButtonsContainer buttons={2}>
            <BaseButton
              type={'primary'}
              icon={'plus'}
              text={'Criar'}
              onClick={() => history.push('/teams/add')}
            />
            <BaseButton
              type={'default'}
              icon={'sync'}
              text={'Atualizar'}
              onClick={() => this.updateDataTable()}
            />
          </HeaderButtonsContainer>
        </HeaderContainer>
        <PageContainer>
          <Row type="flex" justify="end">
            <MultiOptionButton
              buttons={['Mapa de equipa']}
              title={'Exportar'}
              icon="download"
              onPressChoice={this.onPressChoice}
            />
          </Row>

          <TeamsFilters queryChange={this.handleFilterChange} />
          <Table
            columns={columns}
            currentPage={currentPage}
            pageSize={pageSize}
            loading={loading}
            rows={rows}
            showHeader={true}
            emptyIcon="solution"
            emptyText={'Não existe nenhuma equipa'}
            total={total}
            rowKey={'_id'}
            hasPagination={true}
            onPressRow={this.handleOnPressRow}
            onSortChange={this.handleTableChange}
            handleChangePage={this.handleChangePage}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </PageContainer>
      </React.Fragment>
    );
  }
}

export default TeamsPage;
